import { getCorrelationDelta } from '../general/getCorrelationDelta';
import { getCorrelationsByAtomType } from '../general/getCorrelationsByAtomType';
/**
 * Sorts the correlations according to its atom type value and signal delta.
 *
 * @param {Values} values
 */
export function sortCorrelations(correlations) {
    const compareAtomTypes = (atomType1, atomType2) => {
        // C and H highest priority
        if (atomType1 === 'C') {
            return -1;
        }
        if (atomType2 === 'C') {
            return 1;
        }
        if (atomType1 === 'H') {
            return -1;
        }
        if (atomType2 === 'H') {
            return 1;
        }
        // alphabetical sort
        if (atomType1 < atomType2) {
            return -1;
        }
        if (atomType1 > atomType2) {
            return 1;
        }
        return 0;
    };
    const compareCorrelations = (corr1, corr2) => {
        if (corr1.pseudo === false &&
            corr2.pseudo === false &&
            corr1.link.length > 0 &&
            corr2.link.length > 0) {
            const corr1Delta = getCorrelationDelta(corr1);
            const corr2Delta = getCorrelationDelta(corr2);
            if (corr1Delta !== undefined && corr2Delta !== undefined) {
                if (corr1Delta < corr2Delta) {
                    return -1;
                }
                else if (corr1Delta > corr2Delta) {
                    return 1;
                }
            }
        }
        if (corr1.pseudo === false && corr2.pseudo === true) {
            return -1;
        }
        if (corr1.pseudo === true && corr2.pseudo === false) {
            return 1;
        }
        if (corr1.label.origin < corr2.label.origin) {
            return -1;
        }
        if (corr1.label.origin > corr2.label.origin) {
            return 1;
        }
        return 0;
    };
    let sortedCorrelations = [];
    const atomTypes = correlations
        .map((correlation) => correlation.atomType)
        .filter((atomType, i, a) => a.indexOf(atomType) === i);
    atomTypes.sort(compareAtomTypes);
    atomTypes.forEach((atomType) => {
        const correlationsAtomType = getCorrelationsByAtomType(correlations, atomType);
        correlationsAtomType.sort(compareCorrelations);
        sortedCorrelations = sortedCorrelations.concat(correlationsAtomType);
    });
    return sortedCorrelations;
}
//# sourceMappingURL=data:application/json;base64,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